var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCard = function SvgCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.889 4h16a.889.889 0 0 1 .889.889V19.11a.889.889 0 0 1-.89.889h-16A.889.889 0 0 1 3 19.111V4.89A.889.889 0 0 1 3.889 4ZM19 11.111H4.778v7.111H19v-7.11Zm0-1.778V5.778H4.778v3.555H19Zm-5.333 5.334h3.555v1.777h-3.555v-1.777Z",
    fill: "#1D1737"
  })));
};
export default SvgCard;